// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn_click[data-v-41c033ad] {\n  height: 32.67px ;\n  width:  50.67px;\n  text-align: center;\n  line-height: 32.67px;\n  font-weight: 700;\n}\n.text_color[data-v-41c033ad]{\n  color: #1a96d4;\n}\n.pages_w[data-v-41c033ad]{\n  margin-top: 10px;\n}\n.page_box[data-v-41c033ad]{\n  margin-left: 25%;\n  cursor: pointer;\n}\n\n", ""]);
// Exports
module.exports = exports;
